import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=35cced72&scoped=true"
import script from "./HistoryList.vue?vue&type=script&lang=js"
export * from "./HistoryList.vue?vue&type=script&lang=js"
import style0 from "./HistoryList.vue?vue&type=style&index=0&id=35cced72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cced72",
  null
  
)

export default component.exports